import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PageHeading, SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';

import { ServicingSection } from 'web-ui-components/lib/global/layout';
import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';
import { goToCOPPage } from '../../states/actions';
import { pages } from '../../../states/page/actions';
import { copAccountTypes } from '../../../config';

function Blocked({ content, handleCancel, goToCOPPage, copDetails = {}, setKeepAsIs }) {
	const {
		keepButtonText,
		cancelButtonText,
		blockedHeading,
		blockedHeaderDetail,
		blockedFooter,
		blockedFooterDetailBusiness,
		blockedFooterDetailPersonal,
	} = content;
	const { accountType = false } = copDetails;

	const keepAsIsButton = (
		<NavigationButton.Primary
			labelText={keepButtonText}
			onClick={() => {
				setKeepAsIs(true);
				goToCOPPage(pages.COP.AccountWarning);
			}}
			data-test-id="cop-blocked-keep-as-is-button"
		/>
	);
	const CancelTertiaryButton = <NavigationButton.Tertiary labelText={cancelButtonText} onClick={handleCancel} />;
	const payeeAccountType = accountType ? copAccountTypes[accountType] : copAccountTypes.Personal;

	return (
		<ServicingSection>
			<PageHeading data-test-id="match-blocked">{blockedHeading}</PageHeading>
			<p>{blockedHeaderDetail}</p>
			<SubsectionHeading>{blockedFooter}</SubsectionHeading>
			<p>{payeeAccountType === copAccountTypes.Business ? blockedFooterDetailBusiness : blockedFooterDetailPersonal}</p>
			<NavigationButtonGroup primaryButton={keepAsIsButton} tertiaryButtons={CancelTertiaryButton} />
		</ServicingSection>
	);
}

Blocked.propTypes = {
	content: PropTypes.shape({}),
	handleCancel: PropTypes.func,
	goToCOPPage: PropTypes.func.isRequired,
	copyText: PropTypes.shape({}),
};

export default compose(connect(null, { goToCOPPage }), withContent({ content: copContent }))(Blocked);
